/**
 * Created with IntelliJ IDEA.
 * User: elinar
 * Date: 12/9/14
 * Time: 7:44 PM
 * To change this template use File | Settings | File Templates.
 */

define(function (require) {
    "use strict";
    var CP_CONST = require("connection-const");
    var Loader = require("ui/loader/Loader");
    var SearchView = require("connection-views/SearchView");
    var KPsSearchResultsCollection = require("connection-collections/KPsTab/KPsSearchResultsCollection");
    var KPsSnippetsCompositeView = require("connection-views/KPsTab/KPsSnippetsCompositeView");
    var KPsSnippetsCompositeModel = require("connection-models/KPsTab/KPsSnippetsCompositeModel");

    var KPsSearchController = {};
    LE.module('LEConnection', function (LEConnection, LE, Backbone, Marionette, $, _) {
            KPsSearchController = Marionette.Controller.extend({
                referrerAction:CP_CONST.REFERER_ACTION.SEARCH_RESULTS_SNIPPET,

                initialize: function (options) {
                    this.connectionPanelContextModel = options.connectionPanelContextModel;
                    this._initViews();
                    this._bindEvents();
                },

                _initViews: function () {
                    this.searchView = new SearchView({placeholder: LE.translator.translate("LEConnection.connectionPanel.kpSearch")});
                    LEConnection.vent.trigger("KPsTabController::showRegion:searchInputRegion", {view: this.searchView});
                },

                _bindEvents: function () {
                    this.listenTo(this.searchView, SearchView.TRIGGERING.INIT_SEARCH, this._initSearch, this);
                    this.listenTo(this.searchView, SearchView.TRIGGERING.CLEAR_INPUT, this._hideSearchResultsCompositeView, this);
                    this.listenTo(this.connectionPanelContextModel, "change:selectedKP", this._onSelectedKPChange, this);
                },

                _initSearch: function (options) {
                    if (options.searchTerm === "") {
                        this._noSearchTerm();
                    }
                    else {
                        this._runSearchProcess(options);
                    }
                },

                _noSearchTerm: function () {
                    this._hideSearchResultsCompositeView();
                },
                _getKpsSearchResultsCollection: function () {
                    if (!this.kpsSearchResultsCollection) {
                        this.kpsSearchResultsCollection = new KPsSearchResultsCollection();
                    }
                    return this.kpsSearchResultsCollection;
                },
                _runSearchProcess: function (options) {
                    var encodedSearchTerm = encodeURIComponent(options.searchTerm);
                    this._setLoader();
                    this._fetch(encodedSearchTerm);
                },

                _fetch:function(encodedSearchTerm){
                    this._getKpsSearchResultsCollection().fetch({
                        lang: this.connectionPanelContextModel.get("locale"),
                        search: encodedSearchTerm,
                        userId:this.connectionPanelContextModel.get("userId"),
                        accountId:this.connectionPanelContextModel.get("accountId"),
                        success: _.bind(this._onSearchSuccess, this),
                        error: _.bind(this._onSearchError, this),
                        reset:true
                    });
                },
                _onSearchSuccess: function (options) {
                    LEConnection.logger.debug("KPsSearchController:_initSearch - success");
                    this._closeLoader();
                    this._showSearchResultsCompositeView();
                    LEConnection.vent.trigger("KPsTabController:scrollTop");
                },
                _onSearchError: function (options) {
                    LEConnection.logger.error("KPsSearchController:_initSearch - Failed to fetch data");
                    this._closeLoader();
                    this.kpsSearchResultsCollection.reset();
                    this._hideSearchResultsCompositeView();
                    LEConnection.notifier.showError(LE.translator.translate("LEConnection.content.is.unavailable"));
                },
                _hideSearchResultsCompositeView: function () {
                    LEConnection.vent.trigger("KPsTabController::closeRegion:searchResultsRegion");
                },
                _showSearchResultsCompositeView: function () {
                    if (!this.searchResultsCompositeView) {
                        this._setSearchResultsCompositeView();
                    }

                    //if (_.isUndefined(this.searchResultsCompositeView.isClosed) || this.searchResultsCompositeView.isClosed) {
                        LEConnection.vent.trigger("KPsTabController::showRegion:searchResultsRegion", {view: this.searchResultsCompositeView});
                   // }
                },
                _setSearchResultsCompositeView: function () {
                    var kpsSnippetsCompositeModel = new KPsSnippetsCompositeModel({
                        listTitle: LE.translator.translate("LEConnection."+this.referrerAction)
                    });
                    this.searchResultsCompositeView = new KPsSnippetsCompositeView({
                        model:kpsSnippetsCompositeModel,
                        collection: this.kpsSearchResultsCollection,
                        type: this.referrerAction
                    });

                },
                _onSelectedKPChange: function (model, selectedKP) {
                     if (this.searchResultsCompositeView) {
                        if (selectedKP && this.referrerAction === this.connectionPanelContextModel.get("referrerAction")) {
                            var slug = selectedKP.get("slug");
                            this.searchResultsCompositeView.setSelected(slug);
                        }
                        else {
                            this.searchResultsCompositeView.unSelectAll();
                        }
                     }
                },

                findSlugInCollection: function (slug) {
                    var returnedModel;

                    if(this.kpsSearchResultsCollection) {
                        returnedModel = this.kpsSearchResultsCollection.findWhere({slug: slug});
                    }

                    return returnedModel;
                },
                _setLoader:function(){
                    LEConnection.vent.trigger("KPsTabController::loader:show");
                },
                _closeLoader: function () {
                    LEConnection.vent.trigger("KPsTabController::loader:hide");
                }



//
            });
    });
    return KPsSearchController;
});

